import * as yup from 'yup'

export const sendMessageSchema = yup.object().shape({
  name: yup.string().required('Full name is required'),
  email: yup.string().email('Invalid email format').required('Email address is required'),
  message: yup.string().required('Message is required'),
})
